var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools-logos"},_vm._l((_vm.items),function(item,index){return _c('img',{key:index,staticClass:"tools-logos__img",attrs:{"src":item.image,"alt":item.alt}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }